import axios from 'axios'
import { TRANSACTIONS } from '../constants/services'
import CoreServices from './coreServices'

class TransactionServices extends CoreServices {
  async getTransactions({ page, perPage }) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/transactions?page=${page}&per_page=${perPage}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async downloadInvoice(id) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/transactions/${id}/download`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        responseType: "blob",
      })

      let filename = "invoice.pdf"
      const disposition = response.headers["content-disposition"]

      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); 
      }

      let data = await response.data

      return { data, filename}
    } catch (error) {
      console.log(error)
      return { error }
    }
  }
}

export default new TransactionServices(TRANSACTIONS.BASE)
